import { Box, Button, IconButton, Typography } from "@mui/material";
import Table from "components/Table";
import { useState } from "react";
import CreateTask from "./tasks/createTask";
import FloatingButton from "components/FloatingButton";
import { Link } from "react-router-dom";
import moment from "moment";
import { deleteRequestTask, getRequestTasks } from "api/services/tasks";
import { ResType } from "types";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import ViewDescription from "./tasks/ViewDescription";
import EditTask from "./tasks/editTask";
import { useConfirm } from "context/ConfirmDialog";

function RequestTasks() {
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(10);
    const [tasksData, setTasksData] = useState<any>([]);
    const [infoOpen, setInfoOpen] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");
    const [totalCount, setTotalCount] = useState<number>(0);


    const { data, isLoading }: ResType = useQuery(
        ["requested-tasks", { limit: pageCount, offset: page * pageCount, clientId: localStorage.getItem("clientId") || "" }],
        getRequestTasks, {
        onSuccess: (data: any) => {
            setTasksData(data?.data?.[0] || []);
            setTotalCount(data?.data?.[1] || 0);
        },
        onError: (err: any) => {
            if (!err?.error) {
                snack.error(`An error occurred while fetching tasks`);
            }
        }
    }
    );
    const columns = [
        { key: "service", title: "Service", render: (row: any) => row?.service?.name || "-", width: "25%" },
        {
            key: "dueDate", title: "Due Date", render: (row: any) => {
                const date = new Date(row?.dueDate);
                return isNaN(date.getTime()) ? "-" : moment(date).format("DD/MM/YYYY");
            }
        },
        {
            key: "description", title: "Description", render: (row: any) => <Button
                onClick={() => {
                    setSelectedDescription(row.notes || "No Description Available");
                    setInfoOpen(true);
                }}
            >
                <Visibility />
            </Button>
        },
        {
            key: "createdAt", title: "Requested At", render: (row: any) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm:ss")
        },
        { key: "actions", title: "Actions", render: (row: any) => row?.task?.taskNumber ? <Typography color="green">Task Created</Typography> : <Actions row={row} /> }
    ];

    return <Box>
        <Table
            sx={{ pb: 0, mb: 0, height: "475px" }}
            pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
            data={tasksData || []}
            columns={columns}
        />
        <CreateTask open={open} setOpen={setOpen} />
        <FloatingButton onClick={() => setOpen(true)} />
        <ViewDescription open={infoOpen} setOpen={setInfoOpen} description={selectedDescription} />
    </Box>;
}

const Actions = ({ row }: any) => {
    const [editData, setEditData] = useState<any>(null);
    const [openEdit, setOpenEdit] = useState(false);
    const confirm = useConfirm();
    const queryClient = useQueryClient();

    const { mutate, isLoading } = useMutation(deleteRequestTask, {
        onSuccess: () => {
            snack.success("Task Request Deleted Successfully");
            queryClient.invalidateQueries("requested-tasks");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });


    const handleDeleteClick = () => {
        confirm({
            msg: `Are you sure you want to delete this task request ?`,
            action: () => {
                mutate({ id: row.id });
            },
        });
    }

    return <Box>
        <IconButton component={"button"} onClick={() => {
            setEditData(row);
            setOpenEdit(true);
        }}>
            <Edit />
        </IconButton>
        <IconButton component={"button"} onClick={() => {
            handleDeleteClick()
        }}>
            <Delete />
        </IconButton>
        <EditTask open={openEdit} setOpen={setOpenEdit} editData={editData} />
    </Box>
}

export default RequestTasks;
